module.exports = __webpack_public_path__ + "img/promo-1.e2494414.png";